import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiListRepository } from '@softline/core';
import {  SOFTLINE_API_TASK_TYPES } from '../workflow.api';
import { TaskType } from '../types/task-type';

@Injectable()
export class TaskTypesRepository extends ReadonlyHttpApiListRepository<TaskType[], undefined> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_TASK_TYPES);
  }
}
